import React from "react";
import {
  Box,
  Typography,
  Popover,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Checkbox,
  Button,
} from "@mui/material";
import { formatText } from "../../../helpers";

// Template For Options
export const TEMPLATE_FOR_OPTIONS = [
  { label: "Quick Reply", value: "QUICK_REPLY" },
  { label: "Payment Reminder", value: "PAYMENT_REMINDER" },
  { label: "Quotation", value: "QUOTATION" },
  {
    label: "Start Conversation",
    value: "START_CONVERSATION",
  },
  {
    label: "Upsell Templates",
    value: "UPSELL_TEMPLATES",
  },
] as const;

interface TemplateForPopoverProps {
  anchorEl: HTMLElement | null;
  selectedOptions: string[];
  onClose: () => void;
  onOptionToggle: (option: string) => void;
  onSave: () => void;
}

export const TemplateForPopover: React.FC<TemplateForPopoverProps> = ({
  anchorEl,
  selectedOptions,
  onClose,
  onOptionToggle,
  onSave,
}) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
          minWidth: 200,
          mt: 1,
        },
      }}
    >
      <Box sx={{ p: 1 }}>
        <Typography
          variant="subtitle2"
          sx={{
            px: 1,
            py: 0.5,
            fontWeight: 600,
            color: "text.secondary",
            borderBottom: "1px solid",
            borderColor: "divider",
            mb: 1,
          }}
        >
          Select Template For
        </Typography>
        <List dense disablePadding>
          {TEMPLATE_FOR_OPTIONS.map((option) => (
            <ListItem key={option.value} disablePadding>
              <ListItemButton
                onClick={() => onOptionToggle(option.value)}
                sx={{
                  borderRadius: 1,
                  py: 0.5,
                  "&:hover": {
                    backgroundColor: "primary.light",
                  },
                }}
              >
                <Checkbox
                  checked={selectedOptions.includes(option.value)}
                  size="small"
                  sx={{
                    color: "primary.main",
                    "&.Mui-checked": {
                      color: "primary.main",
                    },
                  }}
                />
                <ListItemText
                  primary={formatText(option.value)}
                  primaryTypographyProps={{
                    variant: "body2",
                    fontWeight: selectedOptions.includes(option.value)
                      ? 600
                      : 400,
                    color: selectedOptions.includes(option.value)
                      ? "primary.main"
                      : "text.primary",
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            pt: 1,
            mt: 1,
            borderTop: "1px solid",
            borderColor: "divider",
          }}
        >
          <Button
            size="small"
            variant="outlined"
            onClick={onClose}
            sx={{
              textTransform: "none",
              borderRadius: 1,
            }}
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={onSave}
            sx={{
              textTransform: "none",
              borderRadius: 1,
            }}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};
